(function () {
  var sections = document.querySelectorAll('.faq');

  sections.forEach(function (section) {
    var items = section.querySelectorAll('[data-faq-item]');
    var searchInput = section.querySelector('[data-faq-search]');
    var emptyMessage = section.querySelector('[data-faq-empty]');

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-faq-trigger]');
      var panel = item.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        if (isOpen) {
          closePanel(item, trigger, panel);
        } else {
          openPanel(item, trigger, panel);
        }
      });
    });

    function openPanel(item, trigger, panel) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = 'auto';
      var target = panel.scrollHeight;
      panel.style.height = '0px';
      // force reflow so the browser registers the 0px start point
      panel.offsetHeight;
      panel.style.height = target + 'px';

      panel.addEventListener('transitionend', function handler() {
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', handler);
      });
    }

    function closePanel(item, trigger, panel) {
      var current = panel.scrollHeight;
      panel.style.height = current + 'px';
      // force reflow before collapsing
      panel.offsetHeight;
      panel.style.height = '0px';
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');

      panel.addEventListener('transitionend', function handler() {
        panel.hidden = true;
        panel.removeEventListener('transitionend', handler);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim().toLowerCase();
        var visibleCount = 0;

        items.forEach(function (item) {
          var question = (item.getAttribute('data-faq-question') || '').toLowerCase();
          var answer = (item.getAttribute('data-faq-answer') || '').toLowerCase();
          var matches = query === '' || question.indexOf(query) !== -1 || answer.indexOf(query) !== -1;

          item.hidden = !matches;
          if (matches) visibleCount += 1;
        });

        if (emptyMessage) {
          emptyMessage.hidden = visibleCount !== 0;
        }
      });
    }
  });
})();